import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import DotSeparatedElements from "../../dot_separated_elements";
import Reflux from "reflux";
import UserAgentCapabilitiesStore from "../../../react_stores/user_agent_capabilities_store";
import { select } from "lodash";
import PreviewBook, { shouldDisplayPreviewBookButton } from "../../preview_book/preview_book";

export default GrComponentFactory.createClass({
  displayName: "NewsfeedItemFooterActions",

  mixins: [Reflux.connect(UserAgentCapabilitiesStore, "userAgentCapabilities")],

  propTypes: {
    elements: React.PropTypes.arrayOf(React.PropTypes.element),
  },

  filteredElements() {
    return select(this.props.elements, (element) => {
      if (element.type === PreviewBook) {
        return shouldDisplayPreviewBookButton(element.props.book, this.state.userAgentCapabilities);
      }
      return true;
    });
  },
  render() {
    return (
      <div className="gr-newsfeedItem__footerActions">
        <DotSeparatedElements elements={this.filteredElements()}/>
      </div>);
  },
});
